import React, { FC, useContext, useMemo } from 'react';
import FavoritesEmpty from '../types/FavoritesEmpty';
import AgendaVideo from '../types/AgendaVideo';
import { Video } from '../../../api/agenda/videos';
import { useVideoManyFavorite } from '../../../api/favorites';
import { SkeletonLoading } from '../../_components/SkeletonLoading';
import { GlobalContext } from '../../../Global.context';
import FavoritesSprintEmpty from '../types/FavoritesSprintEmpty';

const FavoriteVideos: FC = () => {
  const { data, loading } = useVideoManyFavorite();
  const { isSprintCourse } = useContext(GlobalContext);

  const videos = useMemo(() => {
    return data?.videoManyFavorite || [] as Video[];
  }, [data?.videoManyFavorite]);

  if (loading) {
    return (
      <SkeletonLoading />
    );
  }

  if (videos.length > 0) {
    return (
      <AgendaVideo
        data={videos}
      />
    );
  }

  if (isSprintCourse) {
    return (
      <FavoritesSprintEmpty />
    );
  }

  return (
    <FavoritesEmpty />
  );
};

export default FavoriteVideos;
